import whyChooseMean3Data from "../../data/WhySeo-ny.json";

  export default function Section5() {
    return (
      <div className="w-full SectionWhyChoose">
        <div className="w-full section-container">
          <div className="w-[90%] md:w-[61%] text-center m-[24px_20px] md:mx-auto">
            <h2 className="text-[24px] md:text-[34px] font-bold leading-[32px] md:leading-[41px] text-[#151515] my-[0.67em]">
             Our Performance-Driven SEO Services
            </h2>
            
          </div>
  
          {/* Cards Grid */}
          <div className="boxes p-[2%_0%_3%_0%] flex justify-center flex-wrap w-[85%] mx-auto gap-x-[2%] gap-y-[19px] md:gap-y-[30px]">
            {whyChooseMean3Data.map((item, index) => (
              <div
                key={index}
                className={`${
                  (index + 1) % 2 === 0
                    ? "bg-[#f5f5f5] text-[#373737]"
                    : "bg-[#E42E35] text-white"
                } p-[10%] xs:p-[3%] xl:w-[26%] w-[90%] xs:w-[46%] rounded-lg shadow-lg`}
              >
                <h3 className="md:text-[25px] text-[20px] leading-[24px] font-bold md:leading-[30px] pb-[4%] my-[0.67em] capitalize">
                  {item.title}
                </h3>
                
                <p className="mb-5 text-xs md:text-sm leading-[22px] font-open">
                  {item.text}
                </p>
              </div>
            ))}
          </div>
        </div>
  
        {/* Optional Divider */}
        <div className="line mb-[55px] mt-[1%] md:mt-[5%] md:mb-[4%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
      </div>
    );
  }
  